module.exports = __webpack_public_path__ + "img/22_1@4x.36f534b1.png";